module.exports = "<div class=\"game-view game-view__introduction\">\n  <div class=\"container\">\n    <div class=\"content\">\n\n      <div class=\"actions-wrapper\">\n        <button class=\"btn btn-link btn-next skip-intro-btn float-right\" type=\"button\"\n                data-localize=\"serious_game.introduction.skip_btn\"></button>\n      </div>\n\n      <div class=\"introduction-video embed-responsive embed-responsive-16by9\"></div>\n    </div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/views/partials/game/introduction.html
// module id = 797
// module chunks = 2